export {
  fileInParts,
  getResolutions,
  putImagePath,
  buildRelativePath,
} from './image'
